var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 53.68 26.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3,.cls-4{fill:#fff;}.cls-4{fill-rule:evenodd;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 53.68,
    height: 26.04
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "33.18 14.71 33.18 17.09 35.49 17.09 35.49 25.5 38.29 25.5 38.29 17.09 40.59 17.09 40.59 14.71 33.18 14.71"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M9.43,1.85V3.78A4.56,4.56,0,0,0,6.51,2.6a3.71,3.71,0,0,0-2.8,1.2A4,4,0,0,0,2.56,6.7,3.93,3.93,0,0,0,3.71,9.56a3.77,3.77,0,0,0,2.81,1.17A3.55,3.55,0,0,0,8,10.45a4,4,0,0,0,.69-.38c.24-.16.49-.35.76-.57v2a5.84,5.84,0,0,1-2.93.79,5.43,5.43,0,0,1-3.95-1.61A5.38,5.38,0,0,1,.92,6.71,5.54,5.54,0,0,1,2.29,3a5.39,5.39,0,0,1,4.33-2,5.58,5.58,0,0,1,2.81.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "13.11 1.27 13.11 10.53 16.28 10.53 16.28 12.05 11.48 12.05 11.48 1.27 13.11 1.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.12,1.28V7.77a3.61,3.61,0,0,0,.45,2,2.43,2.43,0,0,0,3.82,0,3.52,3.52,0,0,0,.45-2V1.28h1.63V8.21A3.86,3.86,0,0,1,24.41,11a4.1,4.1,0,0,1-5.86,0,3.86,3.86,0,0,1-1.06-2.81V1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M28.05,12.05V1.28h1.62a7.25,7.25,0,0,1,1.73.16A2.48,2.48,0,0,1,32.49,2a2.78,2.78,0,0,1,.72,1,3,3,0,0,1,.28,1.26,2.55,2.55,0,0,1-.89,2,2.63,2.63,0,0,1,1.35,1A2.86,2.86,0,0,1,34.46,9a2.89,2.89,0,0,1-.9,2.14,3,3,0,0,1-1.2.74,6.89,6.89,0,0,1-1.84.2ZM29.68,5.9h.51a1.86,1.86,0,0,0,1.33-.4,1.54,1.54,0,0,0,.42-1.18,1.49,1.49,0,0,0-.43-1.16,1.83,1.83,0,0,0-1.26-.39h-.57Zm0,4.63h1a2.51,2.51,0,0,0,1.62-.44,1.48,1.48,0,0,0,.54-1.18,1.53,1.53,0,0,0-.52-1.18,2.73,2.73,0,0,0-1.82-.46h-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M9.06,18.32a3,3,0,0,0-2.4-1.19,2.93,2.93,0,0,0-1.16.23,2.86,2.86,0,0,0-.93.62,2.76,2.76,0,0,0-.6.94,3,3,0,0,0-.23,1.17A3.11,3.11,0,0,0,4,21.28a2.82,2.82,0,0,0,.61.94,2.79,2.79,0,0,0,.92.63,3,3,0,0,0,1.15.23,3.22,3.22,0,0,0,2.41-1.15v3.32l-.28.1a10.16,10.16,0,0,1-1.2.34,6,6,0,0,1-1.1.1,5.59,5.59,0,0,1-3.94-1.61,5.8,5.8,0,0,1-1.25-1.81,5.48,5.48,0,0,1-.48-2.3,5.54,5.54,0,0,1,.47-2.28A5.64,5.64,0,0,1,2.52,16a5.84,5.84,0,0,1,1.81-1.18,5.69,5.69,0,0,1,2.16-.42,5.86,5.86,0,0,1,1.26.14A7.34,7.34,0,0,1,9.06,15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "14.1 18.87 18.14 18.87 18.14 14.71 20.95 14.71 20.95 25.49 18.14 25.49 18.14 21.05 14.1 21.05 14.1 25.49 11.29 25.49 11.29 14.71 14.1 14.71 14.1 18.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M29.81,23.62h-4l-.65,1.87h-3l4.11-10.78h3.06l4.1,10.78h-3Zm-.74-2.13L27.81,17.9l-1.26,3.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M52.78,13.41l0,0-1-1,0,0A4.51,4.51,0,0,0,52.92,9.7V9.39a4.46,4.46,0,0,0-1.18-3c-.14,3.25-3.21,5.83-7.11,5.91h-3a6.7,6.7,0,0,0,4.94,2.14h5.72a.64.64,0,0,0,.49-1.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44.48,1.1c-3.42,0-6.22,2.22-6.22,5.07v.3a4.51,4.51,0,0,0,1.16,2.66l0,0-1,1,0,0a.63.63,0,0,0,.48,1.05h5.73C48,11.17,50.7,9,50.7,6.17S47.89,1.1,44.48,1.1m.92,6.76H41.48a.64.64,0,0,1-.65-.63.66.66,0,0,1,.58-.64h3.93a.64.64,0,0,1,.64.64.65.65,0,0,1-.58.63m1.71-1.69H41.48a.63.63,0,0,1-.07-1.26h5.64a.64.64,0,0,1,.06,1.27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ee7091edb3e872f6c8bcce3e7c8a8ff0.svg";
export { ForwardRef as ReactComponent };